import { render, staticRenderFns } from "./envoicolis.vue?vue&type=template&id=5bf8cd78&lang=html&"
import script from "./envoicolis.vue?vue&type=script&lang=js&"
export * from "./envoicolis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports